'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import React from 'react'

// walrus
import Box, { BoxProps } from '../../kit/box'
import Text from '../../kit/text'

// lib
import { ThemeColor } from '../_support'

/* -----------------------------------------------------------------------------
 * BadgePill
 * -------------------------------------------------------------------------- */

export type BadgePillProps = BoxProps & {
  bgColor: ThemeColor
  dotColor?: ThemeColor
  label: string
  labelColor: ThemeColor
}

function BadgePill({
  bgColor,
  dotColor,
  label,
  labelColor,
  ...otherProps
}: BadgePillProps) {
  return (
    <Box
      alignItems='center'
      alignSelf='flex-start'
      bg={bgColor}
      borderRadius='proPill'
      flexDirection='row'
      gap='08'
      px='12'
      py='04'
      {...otherProps}
    >
      {dotColor ? (
        <Box
          bg={dotColor}
          borderRadius='proPill'
          flex='0 0 auto'
          height={7}
          width={7}
        />
      ) : null}
      <Text font='pro.text.12.semibold' textColor={labelColor}>
        {label}
      </Text>
    </Box>
  )
}

export default BadgePill
